import { ElementType } from "react";
import React from "react";
import { formatAggregatedSteps } from "../../../utils/Format";
import BcSteps from "./BcSteps";

interface IProps {
  values: Array<string>;
  selectedTimes?: Array<string | number>;
  bcType: 'hres' | 'ens' | null;
  timestamp?: string;
  as?: ElementType;
}

const Steps = (props: IProps) => {
  const { values, selectedTimes, bcType, timestamp, as = 'div' } = props;
  const Component = as;

  if (!values.length) {
    return <Component>No steps selected.</Component>
  }

  const isRange = values[0].split('-').length > 1;

  if (isRange) {
    return <Component>{values.join(', ')}</Component>
  } else {
    const valuesAsNumbers = values.map(value => parseInt(value, 10));

    if (bcType && selectedTimes) {
      const timesAsNumbers = selectedTimes.map((t: string | number) => parseInt(t.toString(), 10));

      return (
        <BcSteps steps={valuesAsNumbers} times={timesAsNumbers} type={bcType} as={as} timestamp={timestamp} />
      )
    }

    return (
      <Component>
        {formatAggregatedSteps(valuesAsNumbers)}
      </Component>
    )
  }
}

export default Steps;
